import { useQueryParam } from './useQueryParam';

export function useJobAuthKey() {
  return useQueryParam('key');
}

export function useJobAuthKeyHeaders(): { [key: string]: string } {
  const key = useJobAuthKey();
  return key ? { 'keystone-access-key': key } : {};
}
